import { css } from '@emotion/react'
import { Alert, Flow, Heading } from 'bold-ui'
import { Breadcrumb } from 'components/breadcrumb/Breadcrumb'
import { PageContainer } from 'components/layout/PageContainer'
import { PageContent } from 'components/layout/PageContent'
import { useAtendimentosFinalizadosQuery } from 'graphql/hooks.generated'
import { useConfiguracoes } from 'hooks/configuracoes/useConfiguracoes'
import { useServerTime } from 'hooks/useServerTime'
import { Fragment, useState } from 'react'

import { AssinaturaEletronicaAtendInfo } from './components/AssinaturaEletronicaAtendInfo'
import { AssinaturaEletronicaAtendTable } from './components/AssinaturaEletronicaAtendTable'
import { AssinaturaEletronicaAtendTableFilter } from './components/AssinaturaEletronicaAtendTableFilter'
import {
  convertAssinaturaFilterModelToInput,
  getDefaultPeriodoAssinaturaDigital,
} from './converter-assinaturaEletronicaAtend'
import {
  AssinaturaEletronicaAtendTableFilterModel,
  CriterioExibicaoAtendimento,
} from './model-assinaturaEletronicaAtend'

const SIZE_PAGE = 10

export function AssinaturaEletronicaAtendView() {
  const { configuracoes } = useConfiguracoes()
  const { getServerTimeNow } = useServerTime()
  const isAssinaturaRegistrosInativa = !configuracoes.isAssinaturaRegistrosEnabled

  const [currentFilter, setCurrentFilter] = useState<AssinaturaEletronicaAtendTableFilterModel>(() => ({
    criterioExibicao: isAssinaturaRegistrosInativa
      ? CriterioExibicaoAtendimento.ATENDIMENTOS_COM_ASSINATURA
      : CriterioExibicaoAtendimento.TODOS_OS_ATENDIMENTOS,
    periodo: getDefaultPeriodoAssinaturaDigital(getServerTimeNow(), configuracoes.dataAtivacaoAssinaturaRegistros),
    pageParams: {
      page: 0,
      size: SIZE_PAGE,
      sort: ['-dataRegistro'],
    },
  }))

  const { data, loading, refetch } = useAtendimentosFinalizadosQuery({
    variables: { input: convertAssinaturaFilterModelToInput(currentFilter) },
  })

  if (!data) {
    return null
  }

  return (
    <Fragment>
      <Breadcrumb title='Assinatura digital de documentos' />

      <PageContainer
        fluid
        style={css`
          padding: 2rem;
        `}
      >
        <Flow direction='vertical' gap={2} justifyItems='stretch'>
          <Flow direction='vertical' gap={0.5} justifyItems='stretch'>
            <Heading level={1}>Assinatura digital de documentos</Heading>
            {isAssinaturaRegistrosInativa && (
              <Alert type='warning' inline>
                Assinatura de documentos desabilitada na sua instalação.
              </Alert>
            )}
          </Flow>
          <AssinaturaEletronicaAtendTableFilter
            initialValues={currentFilter}
            disabled={isAssinaturaRegistrosInativa}
            onChange={setCurrentFilter}
          />
        </Flow>
      </PageContainer>

      <PageContent fluid>
        <Flow direction='vertical' justifyItems='stretch'>
          <AssinaturaEletronicaAtendInfo periodo={currentFilter.periodo} />
          <AssinaturaEletronicaAtendTable
            data={data}
            loading={loading}
            setCurrentFilter={setCurrentFilter}
            refetch={refetch}
          />
        </Flow>
      </PageContent>
    </Fragment>
  )
}
